import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';

const faqs = [
  {
    question: 'Como funciona a lista de espera para 2025?',
    answer: 'A lista de espera garante prioridade na matrícula para 2025. Ao se inscrever, você receberá atualizações exclusivas e terá acesso preferencial quando as matrículas forem abertas.',
  },
  {
    question: 'Qual é o diferencial do método para TDAH, Dislexia e Autismo?',
    answer: 'O Método PDTE foi desenvolvido especificamente para atender às necessidades únicas de cada condição, com estratégias personalizadas, materiais adaptados e acompanhamento individualizado.',
  },
  {
    question: 'Quantas vezes por semana ocorre o acompanhamento?',
    answer: 'A quantidade de encontros semanais é definida após a análise de perfil, podendo variar entre uma e duas vezes por semana.',
  },
  {
    question: 'Quanto tempo duram os encontros?',
    answer: 'Cada encontro individual tem a duração de 50 minutos.',
  },
  {
    question: 'São passadas atividades para os alunos fazerem em casa?',
    answer: 'Sim, caso seja necessário. A frequência e o tipo de atividade são definidos com base na independência e disponibilidade do aluno. Se houver dificuldade em estudar sozinho, as atividades são realizadas durante os encontros.',
  },
  {
    question: 'Como são definidos os valores dos planos?',
    answer: 'Os valores são personalizados de acordo com o plano escolhido e as necessidades específicas do aluno. Entre em contato conosco para uma avaliação individual e proposta detalhada.',
  },
  {
    question: 'Qual é a duração dos planos?',
    answer: 'Oferecemos planos semestrais e anuais, com flexibilidade para adaptação às necessidades do aluno. A duração ideal é definida após a avaliação inicial.',
  },
  {
    question: 'Como é feito o acompanhamento do progresso?',
    answer: 'Realizamos avaliações periódicas, fornecemos relatórios detalhados e mantemos comunicação constante com a família para garantir o desenvolvimento contínuo do aluno.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-primary/80 max-w-3xl mx-auto">
            Encontre respostas para as principais dúvidas sobre o Método PDTE.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-4 bg-white rounded-lg shadow-md overflow-hidden border border-primary/10"
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-primary/5"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-lg font-semibold text-primary">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-accent" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-accent" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-primary/80">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-primary/80 mb-4">Ainda tem dúvidas?</p>
          <a
            href="https://app.my-whats.com/0ebd27efd9"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-accent text-white rounded-full hover:bg-accent-dark transition-colors"
          >
            <MessageCircle className="h-5 w-5 mr-2" />
            Fale com nossa equipe
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;